import React, { useLayoutEffect, useState } from 'react';
import './ExploreUnknownDarknessMeter.css';

function clampDarknessFillPercent(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return 0;
  }
  return Math.max(0, Math.min(100, n));
}

/**
 * Explore Unknown run darkness meter (sun → fill → eclipse).
 * Used on the map, in-battle flashes, and After Battle boss-win rewards.
 *
 * @param {{
 *   fillPercent?: number,
 *   fromPercent?: number,
 *   toPercent?: number,
 *   tooltipTitle: string,
 *   regionLabel: string,
 *   tooltipBelow?: boolean,
 *   tooltipAlwaysVisible?: boolean,
 *   className?: string,
 * }} props
 */
export default function ExploreUnknownDarknessMeter({
  fillPercent,
  fromPercent,
  toPercent,
  tooltipTitle,
  regionLabel,
  tooltipBelow = false,
  tooltipAlwaysVisible = false,
  className = '',
}) {
  const isAnimated =
    fromPercent != null &&
    toPercent != null &&
    Number.isFinite(Number(fromPercent)) &&
    Number.isFinite(Number(toPercent));
  const initialFill = isAnimated
    ? clampDarknessFillPercent(fromPercent)
    : clampDarknessFillPercent(fillPercent);
  const [displayFill, setDisplayFill] = useState(initialFill);

  useLayoutEffect(() => {
    if (!isAnimated) {
      setDisplayFill(clampDarknessFillPercent(fillPercent));
      return undefined;
    }
    const from = clampDarknessFillPercent(fromPercent);
    const to = clampDarknessFillPercent(toPercent);
    setDisplayFill(from);
    const id = requestAnimationFrame(() => setDisplayFill(to));
    return () => cancelAnimationFrame(id);
  }, [fillPercent, fromPercent, toPercent, isAnimated]);

  const wrapClass = [
    'explore-unknown-darkness-bar-wrap',
    'explore-unknown-darkness-bar-tooltip-host',
    !isAnimated ? 'explore-unknown-darkness-bar-wrap--static' : '',
    tooltipBelow ? 'explore-unknown-darkness-bar-tooltip-host--tooltip-below' : '',
    tooltipAlwaysVisible ? 'explore-unknown-darkness-bar-tooltip-host--tooltip-visible' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapClass} role="group" aria-label={regionLabel} tabIndex={0}>
      <div className="explore-unknown-darkness-tooltip" role="tooltip">
        <p className="explore-unknown-darkness-tooltip-title">{tooltipTitle}</p>
      </div>
      <img src="/images/sun.png" alt="" className="explore-unknown-darkness-bar-icon" />
      <div className="explore-unknown-darkness-track">
        <div
          className="explore-unknown-darkness-fill"
          style={{ width: `${displayFill}%` }}
        />
      </div>
      <img src="/images/eclipsen.png" alt="" className="explore-unknown-darkness-bar-icon" />
    </div>
  );
}
